import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { BaseGridService } from './grid.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationGridService extends BaseGridService {
  protected get baseUrl(): string {
    return `${environment.apiUrl}/v1/organization/non-odata/`;
  }
  
  // You can override default state if needed
  constructor() {
    super();
    this.state = {
      skip: 0,
      take: 10,
      sort: [{ field: 'name', dir: 'asc' }],
      filter: {
        logic: 'and',
        filters: []
      }
    };
  }
  
  // Add organization-specific methods if needed
}